import { render, staticRenderFns } from "./Pagarme.vue?vue&type=template&id=7d2f2730&"
import script from "./Pagarme.vue?vue&type=script&lang=js&"
export * from "./Pagarme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports